/**
 * Generate metadata for PSP pages based on storage type
 * @param {string} storageType - The display name of the storage type (e.g., 'RV', 'Car', 'Climate Controlled')
 * @returns {object} Metadata object with title and description
 */
import { normalizeKeyword } from 'pages/PSPPage/PSPContentMap';
const metadata = {
	rv: {
		title: 'Find Affordable RV Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable RV self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	car: {
		title: 'Find Affordable Car Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable car self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	'climate-controlled': {
		title: 'Find Affordable Climate Controlled Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable climate controlled self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	boat: {
		title: 'Find Affordable Boat Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable boat self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	portable: {
		title: 'Find Affordable Portable Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable portable self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	motorcycle: {
		title: 'Find Affordable Motorcycle Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable motorcycle self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	commercial: {
		title: 'Find Affordable Commercial Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable commercial self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	wine: {
		title: 'Find Affordable Wine Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable wine self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	atv: {
		title: 'Find Affordable ATV Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable ATV self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	bike: {
		title: 'Find Affordable Bicycle Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable bicycle self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	'dirt-bike': {
		title: 'Find Affordable Dirt Bike Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable dirt bike self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	'golf-cart': {
		title: 'Find Affordable Golf Cart Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable golf cart self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	student: {
		title: 'Find Affordable University Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable university self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	truck: {
		title: 'Find Affordable Truck Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable truck self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	'jet-ski': {
		title: 'Find Affordable Jet Ski Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable jet ski self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	kayak: {
		title: 'Find Affordable Kayak Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable kayak self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	military: {
		title: 'Find Affordable Military Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable military self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	'drive-up': {
		title: 'Find Affordable Drive Up Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable drive up self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	'24-hour': {
		title: 'Find Affordable 24 Hour Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable 24 hour self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	vehicle: {
		title: 'Find Affordable Vehicle Self Storage | SelfStorage.com',
		description:
			'Compare thousands of affordable vehicle self storage options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	electricity: {
		title: 'Find Affordable Self Storage with Electricity | SelfStorage.com',
		description:
			'Compare thousands of affordable self storage with electricity options. Research facilities, view prices and photos, read reviews, and reserve today!',
	},
	'what-is': {
		title: 'What Is Self Storage and How Does It Work? | SelfStorage.com',
		description:
			'Learn what self storage is, how it works, and what to expect. Compare amenities, unit sizes, and prices to find the right space for you.',
	},
};

export const getMetadata = (storageType) => {
	const key = normalizeKeyword(storageType);
	return (
		metadata[key] || {
			title: 'Find Affordable Self Storage | SelfStorage.com',
			description:
				'Browse affordable and secure self storage options near you. Placeholder fallback description.',
		}
	);
};
